import React, { useState } from 'react';
import { Send, Eye, EyeOff, Smile } from 'lucide-react';
import { StickerPicker } from '../../utils/stickers';
import { api } from '../../utils/api';

export default function CardInput({ sessionId, participantId, phase, isKudos = false, onSubmitted }) {
  const [content, setContent] = useState('');
  const [isAnon, setIsAnon] = useState(false);
  const [sticker, setSticker] = useState(null);
  const [showStickers, setShowStickers] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!content.trim()) return;
    setLoading(true);
    try {
      const card = await api.cards.create({
        session_id: sessionId, participant_id: participantId,
        phase, content, is_anonymous: isAnon, sticker: sticker || null
      });
      onSubmitted(card);
      setContent(''); setSticker(null); setShowStickers(false);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: 12 }}>
      {showStickers && isKudos && (
        <div style={{ marginBottom: 8 }}>
          <StickerPicker selected={sticker} onSelect={s => { setSticker(s); setShowStickers(false); }} />
        </div>
      )}

      <div style={{ display: 'flex', gap: 6, alignItems: 'flex-end' }}>
        <div style={{ flex: 1 }}>
          {sticker && <div style={{ fontSize: '1.4rem', marginBottom: 4 }}>{sticker} <button className="btn btn-ghost btn-sm" onClick={() => setSticker(null)} style={{ fontSize: 10 }}>✕</button></div>}
          <textarea
            className="input"
            value={content}
            onChange={e => setContent(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(); } }}
            placeholder={isKudos ? "Give kudos to someone..." : "Add your card... (Enter to submit)"}
            rows={2}
            style={{ resize: 'none' }}
          />
        </div>

        <div className="flex-col gap-1">
          {isKudos && (
            <button className={`btn btn-icon btn-sm ${showStickers ? 'btn-primary' : 'btn-ghost'}`}
              onClick={() => setShowStickers(s => !s)} title="Add sticker">
              <Smile size={14} />
            </button>
          )}
          <button
            className={`btn btn-icon btn-sm ${isAnon ? 'btn-secondary' : 'btn-ghost'}`}
            onClick={() => setIsAnon(a => !a)} title={isAnon ? 'Anonymous on' : 'Post anonymously'}>
            {isAnon ? <EyeOff size={14} /> : <Eye size={14} />}
          </button>
          <button className="btn btn-primary btn-icon btn-sm" onClick={submit} disabled={loading || !content.trim()}>
            <Send size={14} />
          </button>
        </div>
      </div>
      <div className="flex items-center gap-2 mt-1">
        <p className="text-xs text-muted">
          {isAnon ? '👁 Posting anonymously' : '📛 Posting with your name'}
        </p>
      </div>
    </div>
  );
}
